<template>
  <!--
    	作者：kmdshop
    	时间：2019-10-24
    	描述：后台母版
    -->
  <div :class="hasChild != null ? 'main' : 'main right-big'">
    <div class="exp"  v-if="w_flag" >
      <div style="position: relative;width: 100%;height: 100%;">
          <a style="color: black; position: absolute;top: -10px;right: -6px;" @click="close">X</a>
        </div>    
          {{ str }}    
    </div>
    
    <!--left menu-->
    <LeftMenu @selectMenu="selectMenuFunc"></LeftMenu>

    <!--right content-->
    <RightContent></RightContent>
  </div>
</template>

<script>
import LeftMenu from '@/views/layout/LeftMenu.vue';
import RightContent from '@/views/layout/RightContent.vue';
import store from '@/store/';
import {delCookie, setCookie} from '@/utils/base.js';
import {
  setSessionStorage,
  getSessionStorage
} from '@/utils/base'
export default {
  components: {
    /*左菜单组件*/
    LeftMenu,
    /*右边内容容器*/
    RightContent
  },
  data() {
    return {
      /*是否有子菜单*/
      hasChild: null,
      /*系统基本数据*/
      baseInfo: {
        shop_name: '',
        user: {},
        version: '',
        app_id:'',
        w7:{},
        qr_code:"",//客服二维码
        qr_icon:"",//kefu图标
        token:"",
        w_flag:false,
        str:"",
      }
    };
  },
  provide: function() {
    return {
      baseInfo: this.baseInfo
    };
  },
  created() {
    if(this.$route.query.from&&this.$route.query.from=='admin'){
      delCookie('baseInfo');
    }
    let rolelist = getSessionStorage('rolelist');
     
     if(rolelist[0].str && rolelist[0].str.length > 0){
       this.w_flag = true;
       this.str = rolelist[0].str;
     }

    this.getBaseInof();
  },
  methods: {
    close(){
      this.w_flag = false
      this.$forceUpdate()
    },
    /*左边子组件传来的参数*/
    selectMenuFunc(param) {
      this.hasChild = param;
    },

    async getBaseInof() {
      let res = await store.dispatch('common/getBaseInfo');
      this.baseInfo.shop_name = res.shop_name;
      this.baseInfo.version = res.version;
      this.baseInfo.user = res.user;
      this.baseInfo.app_id = res.app_id,
      this.baseInfo.w7 = res.w7
      this.baseInfo.qr_code = res.qr_code
      this.baseInfo.qr_icon = res.qr_icon;
      console.log("this.baseInfo:",this.baseInfo)
      if(res.token){
        setCookie("token", res.token);
      }
   
      
    }
  }
};
</script>

<style>
  .exp{
    padding: 15px; width: 200px;z-index:5000;color: red; max-height: 80px;background: #fff;border-radius: 10px;position: fixed;left: 120px;top: 20px;box-shadow: 0 4px 8px 0 rgba(66, 66, 66, 0.6);
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/main.vue